<ul>
  @for (desc of description; track $index) {
    <li>{{ desc }}</li>
  }
</ul>
